
import Vue from "vue"
import {QLayout, QPageContainer} from "quasar"
import Component from "vue-class-component"
import {Route} from "vue-router"

import Sidebar from "./Sidebar.vue"
import AppHeader from "./AppHeader.vue"

@Component({
  components: {
    QLayout,
    QPageContainer,
    Sidebar,
    AppHeader,
  },
})
export default class MainLayout extends Vue {
  isMenuExpanded = false

  private enterTransitionClass = ""
  private leaveTransitionClass = ""

  private beforeEachHandle: () => void

  mounted() {
    this.isMenuExpanded = this.$q.screen.gt.sm

    // Instance router hooks require beforeUpdate and beforeEnter and the later
    // doesn't work well with the transitions
    this.beforeEachHandle = <() => void>this.$router.beforeEach(
      (to, from, next) => {
        this.setTransitionClass(to)
        next()
      }
    )
  }

  destroyed() {
    this.beforeEachHandle()
  }

  get isBreakpointRefVisible() {
    return sessionStorage.getItem("breakpoint-ref") === "true"
  }

  setTransitionClass(to: Route) {
    if (to.path === "/dashboard") {
      this.enterTransitionClass = ""
      this.leaveTransitionClass = <boolean>this.$q.platform.is.desktop
        ? "animated zoomOut"
        : ""
    } else {
      this.enterTransitionClass = "animated zoomIn"
      this.leaveTransitionClass = ""
    }
  }
}
